import { Gender, IdentityValidationType, MaritalStatus, ClaimType, CustomerStatus } from '../enums';
import moment from 'moment';
import { City } from '../interfaces/City';

export class CustomerDetails {

    public ID: number;
    public Name: string;
    public ImageID?: string;
    public FirstName: string;
    public LastName: string;
    public Identity: string;
    public IdentityValidationType: IdentityValidationType;
    public Gender: Gender;
    public BirthDate?: moment.Moment;
    public MaritalStatus: MaritalStatus;
    public Age?: number;

    public FullAddress: string;
    public Address: string;
    public CityID?: number;
    public CityObj? : City;
    public PostalCode: string;
    public Mobile: string;
    public TelHome: string;
    public Tel2: string;
    public Email: string;
    
    public NotificationBySms: boolean;
    public NotificationByEmail: boolean;
    public NotificationByWhatsApp: boolean;
    public CanScheduleOnline: boolean;
    public SendNotificationCopy: boolean;
    public Confidential: boolean;
    public IsHeadOfFamily: boolean;

    public Status: CustomerStatus; // 0-Not Active 1-Active 2-Temp    
    public FamilyRelationTypeID?: number;    
    public Balance: number;

    public UserId?: number; // therapist
    public PriceListID: number;
    public PriceListExpiredAt?: moment.Moment;

    
    

    // additional fields
    public Date1?: moment.Moment;
    public Date2?: moment.Moment;
    public Date3?: moment.Moment;

    public DropDown1?: string;
    public DropDown2?: string;
    public DropDown3?: string;

    public Integer1?: number;
    public Integer2?: number;
    public Integer3?: number;

    public CheckBox1?: boolean;
    public CheckBox2?: boolean;
    public CheckBox3?: boolean;

    public Text1: string;
    public Text2: string;
    public Text3: string;
    public Text4: string;
    public Text5: string;
    public Text6: string;
    public Text7: string;
    public Text8: string;
    public Text9: string;
    public Text10: string;

    constructor(obj?: any) {
        
        this.ID = obj && obj.ID || null; // when the first operand is true AND return the second operand
        this.Name = obj && obj.Name || null;
        this.ImageID = obj && obj.ImageID || null;
        this.FirstName = obj && obj.FirstName || null;
        this.LastName = obj && obj.LastName || null;
        this.Identity = obj && obj.Identity || null;
        this.IdentityValidationType = obj && obj.IdentityValidationType || null;
        this.Gender = obj && obj.Gender || Gender.NotSet;        
        this.BirthDate = obj && obj.BirthDate && moment(obj.BirthDate) || null;
        this.MaritalStatus = obj && obj.MaritalStatus || MaritalStatus.NotSet;
        this.Age = obj && obj.Age || null;

        this.FullAddress = obj && obj.FullAddress || null;
        this.Address = obj && obj.Address || null;
        this.CityID = obj && obj.CityID || null;
        this.CityObj = obj && obj.CityObj || null;
        this.PostalCode = obj && obj.PostalCode || null;
        this.Mobile = obj && obj.Mobile || null;
        this.TelHome = obj && obj.TelHome || null;
        this.Tel2 = obj && obj.Tel2 || null;
        this.Email = obj && obj.Email || null;        
        
        this.NotificationBySms = obj && obj.NotificationBySms || false;
        this.NotificationByEmail = obj && obj.NotificationByEmail || false;
        this.NotificationByWhatsApp = obj && obj.NotificationByWhatsApp || false;
        this.CanScheduleOnline = obj && obj.CanScheduleOnline || false;
        this.SendNotificationCopy = obj && obj.SendNotificationCopy || false;
        this.Confidential = obj && obj.Confidential || false;
        this.IsHeadOfFamily = obj && obj.IsHeadOfFamily || false;

        this.Status = obj && obj.Status || CustomerStatus.Active; 
        this.FamilyRelationTypeID = obj && obj.FamilyRelationTypeID || null; 
        this.Balance = obj && obj.Balance || 0; 

        this.UserId = obj && obj.UserId || null; // therpiast
        this.PriceListID = obj && obj.PriceListID || null; 
        this.PriceListExpiredAt = obj && obj.PriceListExpiredAt && moment(obj.PriceListExpiredAt) || null; 

        // additional fields
        this.Date1 = obj && obj.Date1 && moment(obj.Date1) || null;
        this.Date2 = obj && obj.Date2 && moment(obj.Date2) || null;
        this.Date3 = obj && obj.Date3 && moment(obj.Date3) || null;

        this.DropDown1 = obj && obj.DropDown1 || null;
        this.DropDown2 = obj && obj.DropDown2 || null;
        this.DropDown3 = obj && obj.DropDown3 || null;

        this.Integer1 = obj && obj.Integer1 || null;
        this.Integer2 = obj && obj.Integer2 || null;
        this.Integer3 = obj && obj.Integer3 || null;

        this.CheckBox1 = obj && obj.CheckBox1 || false;
        this.CheckBox2 = obj && obj.CheckBox2 || false;
        this.CheckBox3 = obj && obj.CheckBox3 || false;

        this.Text1 = obj && obj.Text1 || null;
        this.Text2 = obj && obj.Text2 || null;
        this.Text3 = obj && obj.Text3 || null;
        this.Text4 = obj && obj.Text4 || null;
        this.Text5 = obj && obj.Text5 || null;
        this.Text6 = obj && obj.Text6 || null;
        this.Text7 = obj && obj.Text7 || null;
        this.Text8 = obj && obj.Text8 || null;
        this.Text9 = obj && obj.Text9 || null;
        this.Text10 = obj && obj.Text10 || null;
        
    }
}